/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { opportunitySchema } from './opportunity-schema';
import { userSchema } from './user-schema';

export const opportunityCollaboratorSchema: z.AnyZodObject = z.object({
  collaboratorId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  updatedAt: z.string().datetime().nullish(),
  user: z.lazy(() => userSchema).nullish(),
});

export type OpportunityCollaborator = z.infer<typeof opportunityCollaboratorSchema>;
